module.exports = __webpack_public_path__ + "img/DE04621.0581433f.png";